export const PLAY_STORE_URL = 'https://play.google.com/store/apps/details?id=com.qovoltis.client';
export const APP_STORE_URL = 'https://apps.apple.com/fr/app/qovoltis/1524983586';
